<template>
  <div v-if="!item.hidden">
    <template v-if="hasMoreThanOneChild(item)">
      <el-submenu :index="resolvePath(item.meta.activePath || item.path)">
        <template slot="title">
          <i
            class="menu-icon"
            :class="item.meta.icon"
            v-if="item.meta.icon"
          ></i>
          <span>{{ item.meta.title }}</span>
        </template>
        <SidebarItem
          v-for="child in item.children"
          :key="child.path"
          :item="child"
          :base-path="resolvePath(item.path)"
        ></SidebarItem>
      </el-submenu>
    </template>

    <el-menu-item
      v-else
      :index="resolvePath(item.meta.activePath || item.path)"
      @click="handleMenuItemClick(item.path)"
    >
      <i class="menu-icon" :class="item.meta.icon" v-if="item.meta.icon"></i>
      <span slot="title">{{ item.meta.title }}</span>
    </el-menu-item>
  </div>
</template>

<script>
import path from 'path';

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  methods: {
    // 没有 hidden 属性 的 子路由 大于 1个
    hasMoreThanOneChild({ children = [], showChildren = true }) {
      if (!showChildren) {
        return false;
      }
      return (
        children.length > 1 && children.filter(item => !item.hidden).length >= 1
      );
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
    handleMenuItemClick(routePath) {
      const path = this.resolvePath(routePath);
      if (path === this.$route.path) {
        return;
      }
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;

  background-repeat: no-repeat;
  vertical-align: middle;
}
.icon-home {
  background-image: url(~@/assets/images/icon_home.svg);
}
.icon-income {
  background-image: url(~@/assets/images/icon_income.svg);
}
.icon-charts {
  background-image: url(~@/assets/images/icon_charts.svg);
}
.icon-account {
  background-image: url(~@/assets/images/icon_account.svg);
}
.icon-studio {
  background-image: url(~@/assets/images/ico_studio.svg);
}
.icon-activity {
  background-image: url(~@/assets/images/icon_activity.png);
}
.icon-cloudServ {
  background-image: url(~@/assets/images/ico_cloudServ.svg);
}
.icon-act {
  background-image: url(~@/assets/images/icon_act.svg);
  background-size: 20px;
}
.icon-creation {
  background-image: url(~@/assets/images/ico_creat.png);
}
.el-submenu .el-menu-item {
  padding-left: 51px !important;
}
.el-menu-item.is-active {
  background-color: #fff5e9;
  .icon-home {
    background-image: url(~@/assets/images/icon_home_active.svg);
  }
  .icon-income {
    background-image: url(~@/assets/images/icon_income_active.svg);
  }
  .icon-charts {
    background-image: url(~@/assets/images/icon_charts_active.svg);
  }
  .icon-act {
    background-image: url(~@/assets/images/icon_act_active.svg);
    background-size: 20px;
  }
  .icon-activity {
    background-image: url(~@/assets/images/icon_activity.png);
  }
  .icon-account {
    background-image: url(~@/assets/images/icon_account_active.svg);
  }
  .icon-studio {
    background-image: url(~@/assets/images/ico_studio_active.svg);
  }
  .icon-cloudServ {
    background-image: url(~@/assets/images/ico_cloudServ_active.svg);
  }
}
</style>
